// TODO GA9-1627: remove this file once inspector onboarding is fully released

export const BOOLEAN_OPTIONS = [{ value: 'true', display: 'Yes' }, { value: 'false', display: 'No' }];
